
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 469.333 469.333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M234.667 0C105.271 0 0 114.844 0 256v117.333C0 379.224 4.776 384 10.667 384h32v42.667c0 23.531 19.135 42.667 42.667 42.667h32a10.66 10.66 0 0010.667-10.667v-192A10.66 10.66 0 00117.334 256h-32c-23.531 0-42.667 19.135-42.667 42.667V256c0-117.635 86.135-213.333 192-213.333s192 95.698 192 213.333v42.667C426.667 275.135 407.531 256 384 256h-32a10.66 10.66 0 00-10.667 10.667v192A10.66 10.66 0 00352 469.334h32c23.531 0 42.667-19.135 42.667-42.667V384h32c5.891 0 10.667-4.776 10.667-10.667V256C469.333 114.844 364.063 0 234.667 0z"}})])
          )
        }
      }
    